import ExternalSearchBarActionControl from './ExternalSearchBarActionControl';

export default ExternalSearchBarActionControl;
